import { LuPin as Pin, LuX as X } from 'react-icons/lu';
import { Card, Badge, Button, Alert } from 'react-bootstrap';
import './opportunityChat.scss';
import { t } from 'i18next';
import { Message } from './TextMessage';

type PinnedMessagesAlertProps = {
    pinnedMessages: Message[];
    scrollToMessage: (messageId: string) => void;
    handleUnpinMessage: (messageId: string) => void;
    handleUnpinAllMessages: (e: any) => void;
    canPinMessages?: boolean
}

export const PinnedMessagesAlert: React.FC<PinnedMessagesAlertProps> = ({
    pinnedMessages,
    scrollToMessage,
    handleUnpinMessage,
    handleUnpinAllMessages,
    canPinMessages
}) => {
    return (
        <Alert variant="warning" className="mb-0 border-bottom">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center">
                    <Pin size={16} className="me-2" />
                    <Badge bg="warning" text="dark">
                        {pinnedMessages.length} {t('pinned')}
                    </Badge>
                </div>
                <Button
                    variant="link"
                    disabled={!canPinMessages}
                    className="p-0 text-muted"
                    onClick={handleUnpinAllMessages}
                    style={{ textDecoration: 'none' }}
                >
                    <X size={16} />
                </Button>
            </div>

            <div className="d-flex flex-column gap-2">
                {pinnedMessages.map(msg => (
                    <Card key={`pinned-${msg.id}`} className="p-2" style={{ cursor: 'pointer', borderRadius: 6 }}>
                        <div
                            className="d-flex justify-content-between align-items-center"
                            onClick={() => scrollToMessage(msg.id)}
                        >
                            <div className="flex-grow-1 text-truncate">
                                <div className="small fw-medium text-muted">
                                    <Pin size={12} className="me-1" />
                                    <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                        {msg.isOwn ? t('you') : msg.sender}
                                    </small>
                                </div>
                                <div className="small text-truncate" style={{ whiteSpace: 'pre-line' }}>{msg.text}</div>
                            </div>
                            <Button
                                variant="link"
                                size="sm"
                                disabled={!canPinMessages}
                                className="ms-2 p-1 border-0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleUnpinMessage(msg.id);
                                }}
                            >
                                <X size={14} />
                            </Button>
                        </div>
                    </Card>
                ))}
            </div>
        </Alert>
    );
};
